import { useFetcher } from 'react-router';
import React from 'react';
import type { Locality } from '@modules/ecommerce/type/locality';
import type { Coordinate } from '@modules/location/hook/use-current-coordinates';
import type { loader } from '~/routes/remix-api.ecommerce.get-closest-locality';

const useClosestLocality = () => {
    const [locality, setLocality] = React.useState<Locality | null>(null);

    const fetcher = useFetcher<typeof loader>();

    const search = (coordinate: Coordinate | null) => {
        setLocality(null);
        if (!coordinate) {
            return;
        }

        fetcher.submit(
            {
                latitude: coordinate.Latitude.toString(),
                longitude: coordinate.Longitude.toString(),
            },
            {
                method: 'get',
                action: '/remix-api/ecommerce/get-closest-locality',
            },
        );
    };

    const isFetcherDone = fetcher.state === 'idle' && fetcher.data != null;

    const found = fetcher.data?.Localities?.nodes[0];

    React.useEffect(() => {
        if (isFetcherDone && found) {
            setLocality((l) => (l?.ID === found.ID ? l : found));
        }
    }, [isFetcherDone, found]);

    return {
        locality,
        loading: fetcher.state !== 'idle',
        search,
    };
};

export default useClosestLocality;
